import React from "react";

const Java_Palindrome_Check = () => {
  return (
    <div>
      <h1>Java Palindrome Check</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Palindrome Check in Java.</p>
    </div>
  );
};

export default Java_Palindrome_Check;
